import { from, switchMap } from 'rxjs';

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '@core/services';
import { environment } from '@env/environment';
import { SKIP_AUTH } from './skip-auth.context';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  
  if (req.context.get(SKIP_AUTH)) {
    return next(req);
  }

  const storageService = inject(StorageService);
  const token = storageService.get<string>(environment.tokenName);

  return from(token).pipe(
    switchMap((token) => {
      if (token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }

      return next(req);
    }),
  );
};
